"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../../modules/AppModule");

var EntityEventConverter_1 = require("./conversions/EntityEventConverter");

var EntityEventConverterImpl_1 = require("./conversions/EntityEventConverterImpl");
/**
 * @author OPt
 */


var EntityEventAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(EntityEventAppModule, _AppModule_1$AppModul);

  function EntityEventAppModule() {
    var _this;

    _classCallCheck(this, EntityEventAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityEventAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'entityEvent';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(EntityEventAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(EntityEventConverter_1.EntityEventConverter).to(EntityEventConverterImpl_1.EntityEventConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return EntityEventAppModule;
}(AppModule_1.AppModule);

exports.EntityEventAppModule = EntityEventAppModule;